import { every, isUndefined, reject } from 'lodash-es'

const lineLike: ElementTypes[] = ['beams', 'columns', 'purlins', 'rips', 'lintels']
const slabAndRoofBeamLike: ElementTypes[] = ['slab_beams', 'roof_slab_beams']

const multiEditConfig = (
  elements: (
    | ShapeObject
    | ShapeObjectLine
    | PositionForVertical
    | { opening: Opening; wall: ShapeObject; indexInWall: number }
  )[],
) => {
  const filteredElements = reject(elements, el => isUndefined(el))

  const onlyOpenings = every(filteredElements, el => 'opening' in el)

  const onlyOuterWalls = every(
    filteredElements,
    el => 'element_type' in el && el.element_type === 'outer_walls',
  )
  const onlyInnerWalls = every(
    filteredElements,
    el => 'element_type' in el && el.element_type === 'inner_walls',
  )
  const onlyWalls = every(
    filteredElements,
    el =>
      'element_type' in el &&
      (el.element_type === 'inner_walls' || el.element_type === 'outer_walls'),
  )
  const onlyVerticalSlabs = every(
    filteredElements,
    el => 'element_type' in el && el.element_type === 'vertical_slabs',
  )
  const onlyVerticalRoofSlabs = every(
    filteredElements,
    el => 'element_type' in el && el.element_type === 'vertical_roof_slabs',
  )
  const onlyLineLike = every(
    filteredElements,
    el =>
      ('element_type' in el && lineLike.includes(el.element_type as ElementTypes)) ||
      'position_guid' in el,
  )

  const onlyRipsAndLintels = every(
    filteredElements,
    el => 'element_type' in el && (el.element_type === 'rips' || el.element_type === 'lintels'),
  )

  const onlyRips = every(filteredElements, el => 'element_type' in el && el.element_type === 'rips')
  const onlyLintels = every(
    filteredElements,
    el => 'element_type' in el && el.element_type === 'lintels',
  )

  // Slab beams and roof slab beams can be multi-edited together (e.g. hot
  // dimensioning), but not mixed with the other line-like beams.
  const onlySlabAndRoofBeams = every(
    filteredElements,
    el => 'element_type' in el && slabAndRoofBeamLike.includes(el.element_type as ElementTypes),
  )

  return {
    onlyOpenings,
    onlyOuterWalls,
    onlyInnerWalls,
    onlyVerticalSlabs,
    onlyVerticalRoofSlabs,
    onlyLineLike,
    onlyWalls,
    onlyRipsAndLintels,
    onlyRips,
    onlyLintels,
    onlySlabAndRoofBeams,
  }
}

export default multiEditConfig
